var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select-tree',{attrs:{"data":_vm.options_bank_id,"props":_vm.treeProps,"multiple":_vm.multiple,"disabled":_vm.disabled,"collapse-tags":"","default-expand-all":true,"check-strictly":true,"placeholder":"默认"},on:{"change":_vm.selectChange},model:{value:(_vm.selectID),callback:function ($$v) {_vm.selectID=$$v},expression:"selectID"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a31c04ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bank/bank-select-ex.vue
// module id = null
// module chunks = 